import Carousel from 'shared/carousel/carousel'
import ArticleRecommended from './articleRecommended'

const articleRecommended = new ArticleRecommended()
articleRecommended.init()

const recommendedArticlesCarousel = document.getElementById('recommendedArticles-carousel')
if (recommendedArticlesCarousel) {
	const carousel = new Carousel({
		element: recommendedArticlesCarousel,
		itemsToScrollBy: 2
	})
	carousel.init()
}
